import { map } from 'rxjs/operators';
import { DataManagerService } from '../../../../../data/services/DataManager/data-manager.service';
import { AppConstants } from '../../../../../shared/constants/app-constants';
import { TopbarSearchResult } from '../../topbar-search.model';
import { SearchProvider } from '../record-search.model';
import { joinParts, listSearch, REDSHIFT_PARAMS, REDSHIFT_TIMEOUT_MS } from './list-search';

/**
 * Customers — GET /customers (CustomerListComponent's endpoint), searched in Redshift (src=R).
 * Opens /customer/customer-details?id=<customer_id>, as the list does.
 */
export function customersProvider(dataManager: DataManagerService): SearchProvider {
  return {
    group: 'Customers',
    parent: 'customer',
    accepts: () => true,
    search: query => listSearch(dataManager, AppConstants.SERVICE_NAME_CUSTOMER, query,
      REDSHIFT_PARAMS, REDSHIFT_TIMEOUT_MS).pipe(
      map(rows => rows.map(toResult).filter(Boolean))
    )
  };
}

function toResult(row: any): TopbarSearchResult {
  const id = row?.customer_id;
  if (!id) {
    return null;
  }
  return {
    group: 'Customers',
    label: row.name || row.email || String(id),
    sublabel: row.name ? joinParts(row.email, id) : String(id),
    route: ['/customer/customer-details'],
    queryParams: { id }
  };
}
